// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck TODO migrate to functional component
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import { WithTranslations } from 'components/HOC/WithTranslations/WithTranslations';
import { COOKIE_NAME } from 'constants/index';
import type { RootState } from 'reducers/types';
import { isEUMemberAccess, isEmbedded, isFetching } from 'selectors';
import { cookies } from 'utils/cookies/cookies';

import './CookiesBanner.scss';

class CookiesBannerComponent extends Component {
  state = { hasCookie: cookies.read(COOKIE_NAME) };

  handleClick = () => {
    cookies.set(COOKIE_NAME, true);

    this.setState({
      hasCookie: true,
    });
  };

  render() {
    const { cookiePolicyUrl, i18n, isEmbedded, isEUMemberAccess, isFetching } =
      this.props;
    const { hasCookie } = this.state;

    if (isFetching || isEmbedded) {
      return null;
    }

    const shouldShowCookieBanner = !hasCookie && isEUMemberAccess;
    const link = (
      <a
        href={cookiePolicyUrl}
        title={i18n.t('cookiesBanner.linkTitle')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18n.t('cookiesBanner.linkTitle')}
      </a>
    );

    return (
      shouldShowCookieBanner && (
        <div
          className="CookiesBanner"
          role="dialog"
          aria-describedby="CookiesBanner-content"
          aria-label="Cookie Law"
        >
          <button
            type="button"
            className="CookiesBanner-close"
            onClick={this.handleClick}
            aria-label="Close"
            data-testid="cookiesBannerButton"
          />
          <div id="CookiesBanner-content">
            {i18n.t('cookiesBanner.description')} {link}
          </div>
        </div>
      )
    );
  }
}

CookiesBannerComponent.propTypes = {
  cookiePolicyUrl: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired,
  isEUMemberAccess: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state: RootState) => ({
  isEmbedded: isEmbedded(state),
  isFetching: isFetching(state, 'geolocation'),
  isEUMemberAccess: isEUMemberAccess(state),
});

const connector = connect(mapStateToProps);
const CookiesBanner = WithTranslations(
  WithFlysiteUrls(connector(CookiesBannerComponent)),
);

export { CookiesBanner };
